import "core-js/modules/es.array.concat.js";
import { request } from '@/api/index';
import { api3 } from "@api/env";
import store from "@/store";
export function getList(params) {
  return request({
    url: '/api/Task/GetTaskList',
    method: 'get',
    params: params
  });
}
export function getAdminList(params) {
  return request({
    url: '/api/Task/GetTaskListPlus',
    method: 'get',
    params: params
  });
}
export function updateStatus(params) {
  return request({
    url: '/api/Task/SwitchPublic',
    method: 'post',
    params: params
  });
}
export function getMyStruc(params) {
  return request({
    url: '/api/Common/GetMyStrucList',
    method: 'get',
    params: params
  });
}
export function getInfo(params) {
  return request({
    url: '/api/Task/GetInfo',
    method: 'get',
    params: params
  });
}
export function getTaskStaffDetail(params) {
  return request({
    url: '/api/Task/GetTaskStaffDetail',
    method: 'get',
    params: params
  });
}
export function getStrucMsg(params) {
  return request({
    url: '/api/Common/GetStrucMsg',
    method: 'get',
    params: params
  });
}
export function getQCPerson(params) {
  return request({
    url: '/api/Common/GetQCPerson',
    method: 'get',
    params: params
  });
}
export function getStaffsByF(params) {
  return request({
    url: '/api/Common/GetStaffsByF',
    method: 'get',
    params: params
  });
}
export function getPartner(params) {
  return request({
    url: '/api/Common/GetPartner',
    method: 'get',
    params: params
  });
}
export function getManger(params) {
  return request({
    url: '/api/Common/GetManger',
    method: 'get',
    params: params
  });
}
export function saveTask(data) {
  return request({
    url: '/api/Task/SaveTask',
    method: 'post',
    data: data
  });
}
export function getCustomerTasks(data) {
  return request({
    url: '/api/Task/GetCustomerTasks',
    method: 'get',
    params: data
  });
}
export function getTaskBaseInfo(data) {
  return request({
    url: '/api/Task/GetTaskBaseInfo',
    method: 'get',
    params: data
  });
}
export function setChildTasks(data) {
  return request({
    url: '/api/Task/SetChildTasks',
    method: 'post',
    params: data
  });
}
export function getChildTasks(data) {
  return request({
    url: '/api/Task/GetChildTasks',
    method: 'get',
    params: data
  });
}
export function deleteTask(data) {
  return request({
    url: '/api/Task/DeleteTask',
    method: 'post',
    data: data
  });
}
export function getAccountList(id, params) {
  return request({
    baseURL: api3,
    url: "/api/tasks/".concat(id, "/accounts"),
    method: 'get',
    getHeaders: true,
    withCredentials: false,
    params: params
  });
}
export function getAccountItem(uid, id) {
  return request({
    baseURL: api3,
    url: "/api/tasks/".concat(uid, "/accounts/").concat(id),
    method: 'get',
    getHeaders: true,
    withCredentials: false
  });
}
export function createAccount(id, data) {
  return request({
    baseURL: api3,
    url: "/api/tasks/".concat(id, "/accounts"),
    method: 'post',
    data: data,
    output: true,
    withCredentials: false
  });
}
export function updateAccount(uid, id, data) {
  var customHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return request({
    baseURL: api3,
    url: "/api/tasks/".concat(uid, "/accounts/").concat(id),
    method: 'put',
    data: data,
    output: true,
    withCredentials: false,
    customHeaders: customHeaders
  });
}
export function handleTableBatch(uid, data) {
  var customHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return request({
    baseURL: api3,
    url: "/api/tasks/".concat(uid, "/accounts/batch"),
    method: 'post',
    data: data,
    output: true,
    withCredentials: false,
    customHeaders: customHeaders
  });
}
export function delAccount(uid, id) {
  return request({
    baseURL: api3,
    url: "/api/tasks/".concat(uid, "/accounts/").concat(id),
    method: 'delete',
    output: true,
    withCredentials: false
  });
}
export function getControlList(taskId, params) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId),
    method: 'get',
    getHeaders: true,
    params: params,
    withCredentials: false
  });
}
export function getControlHistoryList(taskId, params) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/archived"),
    method: 'get',
    getHeaders: true,
    params: params,
    withCredentials: false
  });
}
export function getAdminControlList(params) {
  return request({
    baseURL: api3,
    url: "/api/confirmations",
    method: 'get',
    getHeaders: true,
    params: params,
    withCredentials: false
  });
}
export function getAdminControlHistoryList(params) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/archived",
    method: 'get',
    getHeaders: true,
    params: params,
    withCredentials: false
  });
}
export function checkDownloadList(params) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/download/confirmFiles",
    method: 'get',
    getHeaders: true,
    params: params,
    withCredentials: false,
    responseType: 'blob',
    output: true,
    timeout: 1800000 // 30分钟
  });
}
export function checkDownloadList2(params, _onDownloadProgress) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/download/confirmFilesV2",
    method: 'get',
    getHeaders: true,
    params: params,
    withCredentials: false,
    responseType: 'blob',
    output: true,
    onDownloadProgress: function onDownloadProgress(progress) {
      _onDownloadProgress(progress);
    },
    timeout: 1800000 // 30分钟
  });
}
export function customDownloadList(data) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/confirmFiles",
    method: 'post',
    getHeaders: true,
    data: data,
    withCredentials: false,
    responseType: 'blob',
    output: true
  });
}
export function customHistoryDownloadList(data) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/ConfirmFiles/archived",
    method: 'post',
    getHeaders: true,
    data: data,
    withCredentials: false,
    responseType: 'blob',
    output: true
  });
}